import Grid from '@mui/material/Grid'
import { cond, min, max } from 'lodash-es'
import styled from '@emotion/styled'

import Link from 'components/common/A'
import { ArrowRight, ArrowLeft } from 'components/common/SVGElements'

const Button = styled.div`
  ${({ theme, $checked }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 32px;
    height: 29px;
    color: ${$checked ? 'white' : theme.palette.text.secondary};
    background-color: ${$checked ? theme.palette.primary.main : 'white'};
    border-radius: ${theme.spacing(1)};
    border: 1px solid ${$checked ? theme.palette.primary.main : 'white'};

    &:hover {
      border-color: ${theme.palette.text.secondary};
    }
  `}
`

const Pagination = ({ page, setPage, pageAmount, urlPath }) => {
  let startPage = cond([
    [(p) => p === 1, () => 1],
    [(p) => p === 2 || p === 3, () => 2],
    [
      (p) => p > 3,
      (p) => (p + 2 > pageAmount ? max([pageAmount - 4, 1]) : p - 2),
    ],
    [() => true, () => 1],
  ])(page)
  const length = min([5, pageAmount - startPage + 1])
  const paginations = Array.from({ length }, (_, i) => i + startPage)

  const onPrevClick = () => setPage(max([page - 1, 1]))
  const onNextClick = () => setPage(min([page + 1, pageAmount]))

  const abortLinkClick = (e) => e.preventDefault()

  return (
    <div>
      <Grid container spacing={1}>
        {page !== 1 && (
          <>
            <Grid item>
              <Link
                onClick={abortLinkClick}
                href={!!urlPath ? `${urlPath}?page=${max([page - 1, 1])}` : ''}
              >
                <Button onClick={onPrevClick}>
                  <ArrowLeft textSecondary />
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link
                onClick={abortLinkClick}
                href={!!urlPath ? `${urlPath}?page=1` : ''}
              >
                <Button onClick={() => setPage(1)}>1</Button>
              </Link>
            </Grid>
          </>
        )}
        {paginations?.map((pagination) => (
          <Grid item key={`page-${pagination}`}>
            <Link
              onClick={abortLinkClick}
              href={!!urlPath ? `${urlPath}?page=${pagination}` : ''}
            >
              <Button
                $checked={page === pagination}
                onClick={() => setPage(pagination)}
              >
                {pagination}
              </Button>
            </Link>
          </Grid>
        ))}
        {page < pageAmount && (
          <Grid item>
            <Link
              onClick={abortLinkClick}
              href={
                !!urlPath
                  ? `${urlPath}?page=${min([page + 1, pageAmount])}`
                  : ''
              }
            >
              <Button onClick={onNextClick}>
                <ArrowRight textSecondary />
              </Button>
            </Link>
          </Grid>
        )}
      </Grid>
    </div>
  )
}

Pagination.defaultProps = {
  page: 1,
  pageAmount: 1,
}

export default Pagination
